export const BASE_API_LOADING = 'BASE_API_LOADING'
export const BASE_API_FAILED = 'BASE_API_FAILED'
export const GET_ALL_SHIP_TYPES_SUCCESS = 'GET_ALL_SHIP_TYPES_SUCCESS'
export const GET_ALL_LOCATION_TYPES_SUCCESS = 'GET_ALL_LOCATION_TYPES_SUCCESS'
